export default function handleInviteFriend(params) {
  const tenantNameRaw = params.get("tenantName") || "";
  // const tenantId = params.get("tenantId");
  const tenantIdRaw = params.get("tenantId") || "";

  // Remove commas and convert to number
  const tenantId = tenantIdRaw ? Number(tenantIdRaw.replace(/,/g, "")) : null;
  const emailIdRaw = params.get("emailId") || "";

  let tenantName = "";
  let emailId = "";
  let decodingError = false;

  // Decode tenantName (Base64 + fallback for old format)
  try {
    if (tenantNameRaw) {
      tenantName = decodeURIComponent(atob(tenantNameRaw));
    }
  } catch (e) {
    try {
      // Fallback for old URLs
      tenantName = decodeURIComponent(tenantNameRaw.replace(/\+/g, " "));
    } catch (fallbackError) {
      tenantName = tenantNameRaw;
      decodingError = true;
    }
  }

  // Decode email (base64)
  try {
    if (emailIdRaw) {
      emailId = decodeURIComponent(atob(emailIdRaw));
    }
  } catch (e) {
    try {
      emailId = decodeURIComponent(emailIdRaw);
    } catch (fallbackError) {
      emailId = emailIdRaw;
      decodingError = true;
    }
  }

  const missingParams = !tenantNameRaw || !tenantId || !emailIdRaw;

  // Extract optional invitation token and inviter information from URL parameters
  const invitationToken = params.get("invitationToken") || params.get("token") || null;
  const inviterInfo = params.get("inviterInfo") || params.get("inviterName") || params.get("inviterId") || null;

  // TODO: Backend Integration - Validate invitation token and inviter details via dedicated backend API when available.
  // Currently, user registration status is determined via API.verifyEmail(mail). If a token validation API is implemented,
  // call it here or in Landing page initialization to verify token authenticity.

  return {
    action: "InviteFriend",
    tenantName,
    tenantId,
    emailId,
    invitationToken,
    inviterInfo,
    decodingError,
    missingParams,
    rawTenantName: tenantNameRaw,
    rawTenantId: tenantIdRaw,
    rawEmailId: emailIdRaw,
  };
}
